import { Component, OnInit } from '@angular/core';
import { ListResponse } from '../../../../../models/list-response';
import { DocumentTemplate, getDocumentTypeDisplay } from '../../../../../models/document-template';
import { AccountService } from '../../../../../services/account/account.service';
import { DocumentTemplateService } from '../../../../../services/document-template/document-template.service';

@Component({
  selector: 'app-document-templates',
  templateUrl: './document-templates.component.html',
  styleUrls: ['./document-templates.component.css']
})
export class DocumentTemplatesComponent implements OnInit {

  public documentTemplateList: ListResponse<DocumentTemplate>;
  public loadingDocumentTemplates = false;

  // The status filter shown beside "Add Document Template" (PRO-863). 'active'
  // (the default) shows live templates; 'retired' shows retired ones.
  public selectedStatus = 'active';

  public serverError: number = null;

  // Make browser history available to the template.
  public history: History;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public getDocumentTypeDisplay = getDocumentTypeDisplay;

  constructor(
    public accountService: AccountService,
    private documentTemplateService: DocumentTemplateService
  ) { }

  ngOnInit() {
    // TODO: Replace with more specific permission?
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }

    // Make browser history available to the template.
    this.history = history;

    this.loadDocumentTemplates();
  }

  /**
   * Reload the list when the status filter changes.
   */
  public onStatusChange() {
    this.loadDocumentTemplates();
  }

  public loadDocumentTemplates() {
    this.loadingDocumentTemplates = true;

    this.documentTemplateService
      .getDocumentTemplates(1, 100, this.selectedStatus)
      .then(response => {
        this.documentTemplateList = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingDocumentTemplates = false;
      });
  }

  /**
   * Whether a non-zero number of results have been loaded.
   */
  public resultsPresent(): boolean {
    return (
      this.documentTemplateList &&
      this.documentTemplateList.results &&
      (this.documentTemplateList.results.length > 0)
    );
  }

}
